






































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KCardFooterBtn,
} from '@kasasa/fbase-components';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { Cycle } from '@/api/cycles';
import TunesSummaryTable from '@/components/summary/TunesSummaryTable.vue';
import TunesGrantsRemainingTable from '@/components/summary/TunesGrantsRemainingTable.vue';

@Component({
  computed: mapState(['fiId']),
  components: {
    KCardFooterBtn,
    TunesSummaryTable,
    TunesGrantsRemainingTable,
  },
})
export default class TunesSummaryCard extends Vue {
  fiId!: string;

  @Prop({ default: null }) cycle!: Cycle | null;

  downloadReport() {
    if (this.cycle) {
      window.location.href = `/api/rcx/reporting/${this.fiId}/tunes-summary-report/${this.cycle.id}`;
    }
  }
}
